interface ControlGuidance {
    visible: boolean;
    turnId: string;
    label: string;
    pictureUrl: string;
}

// Keep the mounted nodes and idle clock across ordinary dock syncs.
const mounted = new WeakMap<HTMLElement, ReturnType<typeof mount>>();

function mount(root: HTMLElement) {
    const text = root.querySelector<HTMLElement>('[data-ft3d-control-guidance-text]')!;
    const button = root.querySelector<HTMLButtonElement>('[data-ft3d-control-turn]')!;
    const avatar = document.createElement('span');
    avatar.className = 'ft3d-control-guidance__avatar';
    avatar.setAttribute('aria-hidden', 'true');
    button.append(avatar, document.createTextNode('Take control'));
    let timer = 0;
    let turnId = '';
    let label = '';
    let pictureUrl = '';
    const cancelIdle = () => { window.clearTimeout(timer); root.classList.remove('is-receded'); };
    const idle = () => {
        cancelIdle();
        if (!root.hidden) timer = window.setTimeout(() => root.classList.add('is-receded'), 6000);
    };
    root.addEventListener('pointerenter', cancelIdle);
    root.addEventListener('pointerleave', idle);
    root.addEventListener('focusin', cancelIdle);
    root.addEventListener('focusout', idle);
    return (state: ControlGuidance) => {
        const changedTurn = turnId !== state.turnId;
        const revealed = root.hidden && state.visible;
        root.hidden = !state.visible;
        if (!state.visible) { cancelIdle(); return; }
        if (revealed || changedTurn) idle();
        if (revealed || changedTurn || label !== state.label) {
            text.textContent = state.turnId ? `${state.label}'s turn` : 'GM overview';
            root.title = state.turnId
                ? `You're in GM overview. Take control of ${state.label} to use the action bar.`
                : 'GM overview. Control a character in the scene to use the action bar.';
            button.title = root.title;
            button.setAttribute('aria-label', `Take control of ${state.label}`);
            button.hidden = !state.turnId;
        }
        if (revealed || changedTurn || label !== state.label || pictureUrl !== state.pictureUrl) {
            // Text is already in place if a portrait fails, including a late error from an old turn.
            avatar.textContent = state.label.slice(0, 2) || '??';
            if (state.pictureUrl) {
                const image = document.createElement('img');
                image.alt = '';
                image.draggable = false;
                image.addEventListener('error', () => image.remove(), { once: true });
                image.src = state.pictureUrl;
                avatar.append(image);
            }
        }
        turnId = state.turnId;
        label = state.label;
        pictureUrl = state.pictureUrl;
    };
}

export function renderFt3dControlGuidance(root: HTMLElement | null, state: ControlGuidance): void {
    if (!root) return;
    let render = mounted.get(root);
    if (!render) { render = mount(root); mounted.set(root, render); }
    render(state);
}
